"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import MemeDropTrait from "./MemeDropTrait";
import { FIELD_TO_LABEL_MAP, MEME_TRAITS_SORT_ORDER } from "@/components/waves/memes/traits/schema";
import { MEMES_SUBMISSION_ADDITIONAL_INFO_KEYS } from "@/components/waves/memes/submission/types/OperationalData";
interface MemeDropTraitsProps {
  readonly drop: ApiDrop;
}
interface MemeDropTrait {
  label: string;
  value: string;
}
const MemeDropTraits: React.FC<MemeDropTraitsProps> = t0 => {
  const $ = _c(21);
  const {
    drop
  } = t0;
  const [showAllTraits, setShowAllTraits] = useState(false);
  const t1 = drop.metadata;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== drop.id || $[1] !== drop.metadata || $[2] !== showAllTraits) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const traits = t1.filter(_temp).sort(_temp2);
      const hasHiddenTraits = traits.length > 2;
      let t7;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = e => {
          e.stopPropagation();
          setShowAllTraits(false);
        };
        $[8] = t7;
      } else {
        t7 = $[8];
      }
      const handleShowLess = t7;
      let t8;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = e_0 => {
          e_0.stopPropagation();
          setShowAllTraits(true);
        };
        $[9] = t8;
      } else {
        t8 = $[9];
      }
      const handleShowAll = t8;
      if (!traits.length) {
        t6 = null;
        break bb0;
      }
      let t9;
      bb1: {
        if (showAllTraits) {
          let t10;
          if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = <button onClick={handleShowLess} className="tw-cursor-pointer tw-self-end tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-pb-1.5 tw-text-left tw-text-xs tw-font-medium tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-iron-300">Show less</button>;
            $[10] = t10;
          } else {
            t10 = $[10];
          }
          t9 = t10;
          break bb1;
        }
        if (!hasHiddenTraits) {
          t9 = null;
          break bb1;
        }
        let t10;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <button onClick={handleShowAll} className="tw-cursor-pointer tw-self-end tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-pb-1.5 tw-text-left tw-text-xs tw-font-medium tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-iron-300">Show all</button>;
          $[11] = t10;
        } else {
          t10 = $[11];
        }
        t9 = t10;
      }
      const traitToggle = t9;
      t5 = "tw-hidden tw-flex-col tw-gap-2 lg:tw-flex";
      t2 = "tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-grid-cols-4";
      let t10;
      if ($[12] !== drop.id) {
        t10 = trait => <MemeDropTrait key={trait.data_key} label={FIELD_TO_LABEL_MAP[trait.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait.data_value ?? ""} dropId={drop.id} />;
        $[12] = drop.id;
        $[13] = t10;
      } else {
        t10 = $[13];
      }
      t3 = traits.slice(0, 2).map(t10);
      t4 = showAllTraits ? <>{traits.slice(2).map(trait_0 => <MemeDropTrait key={trait_0.data_key} label={FIELD_TO_LABEL_MAP[trait_0.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait_0.data_value ?? ""} dropId={drop.id} />)}{traitToggle}</> : traitToggle;
    }
    $[0] = drop.id;
    $[1] = drop.metadata;
    $[2] = showAllTraits;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t7 = <div className={t2}>{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default MemeDropTraits;
function _temp(i) {
  return !MEMES_SUBMISSION_ADDITIONAL_INFO_KEYS.includes(i.data_key);
}
function _temp2(a, b) {
  const aIndex = MEME_TRAITS_SORT_ORDER.indexOf(a.data_key);
  const bIndex = MEME_TRAITS_SORT_ORDER.indexOf(b.data_key);
  return aIndex - bIndex;
}